import { panggilSuara, suaraDariLabel } from '../../../utils/suaraAntrian';
import React, { useCallback, useContext, useMemo, useRef, useState, useEffect } from 'react';
import { bacaTingkat, hargaDasarKeranjang } from '../../../utils/hargaGrosir';
import { useLayarPelanggan } from '../../../hooks/useLayarPelanggan';
import { infoCabang, pesanKeranjang, pesanQris, pesanSelesai } from '../../../utils/layarPelanggan';
import { usePromoKeranjang } from '../../promo/usePromoKeranjang';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import axios from 'axios';

import LayoutRetail from './LayoutRetail';
import ProductDisplayRetail from './ProductDisplayRetail';
import TransaksiRetail from './TransaksiRetail';
import ProfileRetail from './ProfileRetail';
import OrderDetailRetail from './OrderDetailRetail';
import CartRetail from './CartRetail';
import SearchBarRetail from './SearchBarRetail';

import PaymentDialog from './PaymentDialog';     
import SerialDialog from './SerialDialog';       
import CameraDialog from './CameraDialog';       

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Button } from '@mui/material';
import { RetailPrinterContext } from './LayoutRetail';
import { useMidtransCabang } from '../../integrasi/useMidtransCabang';
import { barisStrukKasir } from '../../../struk/strukWeb';
import { cetakBrowser } from '../../../struk/cetakStruk';
import { bacaLaci, harusBukaLaciOtomatis } from '../../../struk/laciKasir';
import StrukPratinjau from '../../../struk/StrukPratinjau';
import { apiHost } from '../../../utils/apiHost';
import { KartuShiftWeb, useShiftKasir } from '../../shift/ShiftKasirWeb';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.msg ||
  error?.message ||
  fallback;

// ─── Halaman Kasir Utama (2-kolom: produk + cart) ────────────────────────────
const KasirPage = ({ baseUrl }) => {
  // ── State ──────────────────────────────────────────────────────────────────
  const [lookupCode, setLookupCode]       = useState('');
  const [lookupLoading, setLookupLoading] = useState(false);
  const [lookupProduct, setLookupProduct] = useState(null);

  const [cart, setCartMentah]             = useState([]);
  // Harga grosir bertingkat: setiap perubahan keranjang menghitung ulang harga satuan menurut total unit tiap produk
  // (utils/hargaGrosir.js; server menghitung ulang saat transaksi disimpan).
  const setCart = useCallback((pembaruan) => {
    setCartMentah((prev) => {
      const berikut = typeof pembaruan === 'function' ? pembaruan(prev) : pembaruan;
      const dasar = hargaDasarKeranjang(berikut.map((c) => ({ id: c.baranguuid, harga: c.hargaDasar, hargaGrosir: c.hargaGrosir, jumlah: c.quantity })));
      return berikut.map((c) => {
        if (c.hargaDasar === undefined) return c;
        const harga = dasar.get(c.baranguuid);
        return c.harga === harga && c.grosir === (harga < c.hargaDasar) ? c : { ...c, harga, grosir: harga < c.hargaDasar };
      });
    });
  }, []);
  const [namaCustomer, setNamaCustomer]   = useState('');
  const [noted, setNoted]                 = useState('');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('cash');

  const [notification, setNotification]   = useState({ open: false, severity: 'info', message: '' });
  const [receiptPreviewOpen, setReceiptPreviewOpen] = useState(false);
  const [receiptPreviewData, setReceiptPreviewData] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [productReloadTick, setProductReloadTick] = useState(0);
  const { printerConnected, printerInstance } = useContext(RetailPrinterContext);
  const user = useSelector((state) => state.auth.user);
  const [cabangConfig, setCabangConfig] = useState(null);
  const [utamaConfig, setUtamaConfig] = useState(null);

  // Layar pelanggan (halaman /layar di server, dibuka dari tombol Layar Pelanggan): belanjaan & total, QR QRIS, lalu terima kasih + kembalian.
  const kirimLayar = useLayarPelanggan();
  const [qrisLayar, setQrisLayar] = useState(null); // { qris, total } dari dialog pembayaran
  const { diskonTotal: diskonLayar, promoNama: promoLayar } = usePromoKeranjang(
    cart.map((item) => ({ baranguuid: item.baranguuid, total: (parseFloat(item.harga) || 0) * item.quantity }))
  );
  const cabangLayar = useMemo(() => infoCabang({
    nama: user?.cabang?.namacabang || user?.cabang?.namaCabang || '',
    logo: cabangConfig?.logo ? `${baseUrl}/uploads/${cabangConfig.logo}` : '',
  }), [user, cabangConfig, baseUrl]);
  useEffect(() => {
    if (qrisLayar) { kirimLayar(pesanQris(qrisLayar, cabangLayar)); return; }
    const bruto = cart.reduce((a, c) => a + (parseFloat(c.harga) || 0) * c.quantity, 0);
    kirimLayar(pesanKeranjang({
      items: cart.map((c) => ({ nama: c.nama, harga: c.harga, qty: c.quantity, grosir: c.grosir, opsi: (c.serialLabels || []).length ? `SN: ${c.serialLabels.join(', ')}` : '' })),
      subtotal: bruto, diskon: diskonLayar, promoNama: promoLayar, total: Math.max(0, bruto - diskonLayar),
    }, cabangLayar));
  }, [cart, qrisLayar, diskonLayar, promoLayar, cabangLayar, kirimLayar]);
  const [nonCashMethods, setNonCashMethods] = useState([]);

  // Dialog states
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const adalahKasir = user?.role === 'kasir';
  const shiftHook = useShiftKasir(adalahKasir);
  const [mintaShift, setMintaShift] = useState(false);
  const [mintaTutupShift, setMintaTutupShift] = useState(false);
  const [cameraOpen, setCameraOpen]               = useState(false);
  const [serialDialogOpen, setSerialDialogOpen]   = useState(false);
  const [serialOptions, setSerialOptions]         = useState([]);
  const [serialSelection, setSerialSelection]     = useState([]);
  const [pendingProduct, setPendingProduct]       = useState(null);

  const inputRef             = useRef(null);
  const lookupByKodebarangRef = useRef(null);

  // ── Helpers ────────────────────────────────────────────────────────────────
  const showNotification = (severity, message) =>
    setNotification({ open: true, severity, message });

  const focusScanner = () => setTimeout(() => inputRef.current?.focus(), 100);

  useEffect(() => { inputRef.current?.focus(); }, []);

  useEffect(() => {
    (async () => {
      try {
        if (user?.cabang?.uuid) {
          const response = await axios.get(`${baseUrl}/getkonfigurasicabang?cabangUuid=${user.cabang.uuid}`, {
            withCredentials: true,
          });
          setCabangConfig(response.data?.data || null);
        }
      } catch {
        setCabangConfig(null);
      }
      try {
        const response = await axios.get(`${baseUrl}/getpengaturanutama`, { withCredentials: true });
        setUtamaConfig(response.data?.data || null);
      } catch {
        setUtamaConfig(null);
      }
      try {
        const response = await axios.get(`${baseUrl}/getnoncashmethod`, { withCredentials: true });
        setNonCashMethods(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch {
        setNonCashMethods([]);
      }
    })();
  }, [user?.cabang?.uuid, baseUrl]);

  const toUploadUrl = (fileName) => (fileName ? `${baseUrl}/uploads/${fileName}` : null);
  const receiptLogoUrl =
    (cabangConfig?.logoTampilStruk !== false && cabangConfig?.logo && toUploadUrl(cabangConfig.logo)) ||
    toUploadUrl(utamaConfig?.logo) ||
    null;
  // QRIS butuh saklar global aktif dan akun Midtrans untuk cabang ini.
  const midtransCabang = useMidtransCabang(user?.cabang?.uuid);
  const qrisEnabled = utamaConfig?.qrisAktif !== false && midtransCabang;

  useEffect(() => {
    if (!qrisEnabled && selectedPaymentMethod === 'qris') {
      setSelectedPaymentMethod('cash');
    }
  }, [qrisEnabled, selectedPaymentMethod]);

  // ── Lookup barcode ─────────────────────────────────────────────────────────
  const lookupByKodebarang = async (kodebarang) => {
    const code = (kodebarang || '').trim();
    if (!code) {
      showNotification('warning', 'Kode barang wajib diisi sebelum scan atau cari.');
      return;
    }
    setLookupLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/retail/barang-by-kodebarang`, {
        params: { kodebarang: code },
        withCredentials: true,
      });
      const product = response.data?.data;
      setLookupProduct(product);
      setLookupCode(code);
      addProductToCart(product);
      showNotification('success', `Barang ${product?.Barang?.namabarang || code} ditambahkan ke keranjang.`);
    } catch (error) {
      setLookupProduct(null);
      showNotification('error', getErrorMessage(error, 'Gagal mencari barang retail.'));
    } finally {
      setLookupLoading(false);
    }
  };
  lookupByKodebarangRef.current = lookupByKodebarang;

  // ── Cart logic ─────────────────────────────────────────────────────────────
  const addProductToCart = (product, serial = null) => {
    if (!product?.Barang?.uuid) return;

    if (!serial) {
      const stok = parseInt(product?.stok, 10) || 0;
      if (stok <= 0) {
        showNotification('error', 'Stok produk habis!');
        return;
      }
      const existingQty = cart.find(
        (item) => item.baranguuid === product.Barang.uuid && !item.isSerialTracked
      )?.quantity || 0;
      if (existingQty + 1 > stok) {
        showNotification('warning', 'Stok tidak mencukupi!');
        return;
      }
    }

    setCart((prev) => {
      if (serial) {
        return [
          ...prev,
          {
            key: `${product.Barang.uuid}-${serial.uuid}`,
            baranguuid: product.Barang.uuid,
            nama: product.Barang.namabarang,
            kodebarang: product.Barang.kodebarang,
            harga: parseFloat(product.Barang.harga),
            hargaDasar: parseFloat(product.Barang.harga),
            hargaGrosir: bacaTingkat(product.hargaGrosir),
            quantity: 1,
            serialNumbers: [serial.uuid],
            serialLabels: [serial.serialNumber],
            isSerialTracked: true,
          },
        ];
      }
      const stok = parseInt(product?.stok, 10) || 0;
      const existingIndex = prev.findIndex(
        (item) => item.baranguuid === product.Barang.uuid && !item.isSerialTracked
      );
      if (existingIndex >= 0) {
        const next = [...prev];
        next[existingIndex] = { ...next[existingIndex], quantity: next[existingIndex].quantity + 1, stok };
        return next;
      }
      return [
        ...prev,
        {
          key: `${product.Barang.uuid}-plain`,
          baranguuid: product.Barang.uuid,
          nama: product.Barang.namabarang,
          kodebarang: product.Barang.kodebarang,
          harga: parseFloat(product.Barang.harga),
          hargaDasar: parseFloat(product.Barang.harga),
          hargaGrosir: bacaTingkat(product.hargaGrosir),
          quantity: 1,
          stok,
          serialNumbers: [],
          serialLabels: [],
          isSerialTracked: false,
        },
      ];
    });
  };

  const incrementCartItem = (item) => {
    if (!item.isSerialTracked && item.quantity + 1 > (item.stok ?? Infinity)) {
      showNotification('warning', 'Stok tidak mencukupi!');
      return;
    }
    setCart((prev) =>
      prev.map((c) => c.key === item.key ? { ...c, quantity: c.quantity + 1 } : c)
    );
  };

  const decrementCartItem = (item) =>
    setCart((prev) =>
      prev
        .map((c) => c.key === item.key ? { ...c, quantity: Math.max(1, c.quantity - 1) } : c)
        .filter((c) => !(c.key === item.key && c.quantity === 1 && item.quantity === 1))
    );

  const removeCartItem = (itemKey) =>
    setCart((prev) => prev.filter((item) => item.key !== itemKey));

  // ── Add from product grid ──────────────────────────────────────────────────
  const handleAddFromDisplay = (product) => {
    if (!product?.Barang?.uuid) return;
    addProductToCart(product);
    showNotification('success', `${product.Barang.namabarang} ditambahkan ke keranjang.`);
  };

  // ── Serial number dialog ───────────────────────────────────────────────────
  const openSerialSelector = async (product) => {
    try {
      const response = await axios.get(`${baseUrl}/serialnumbers/available`, {
        params: { baranguuid: product.Barang.uuid },
        withCredentials: true,
      });
      const usedSerials = new Set(cart.flatMap((item) => item.serialNumbers || []));
      const options = (response.data?.data || []).filter((item) => !usedSerials.has(item.uuid));
      if (!options || options.length === 0) {
        showNotification('info', `Barang ${product.Barang.namabarang} tidak punya serial number atau sudah habis.`);
        return;
      }
      setPendingProduct(product);
      setSerialOptions(options);
      setSerialSelection([]);
      setSerialDialogOpen(true);
    } catch (error) {
      showNotification('error', getErrorMessage(error, 'Gagal memuat serial number tersedia.'));
    }
  };

  const confirmSerialSelection = () => {
    if (!pendingProduct) return;
    if (serialSelection.length === 0) {
      showNotification('warning', 'Pilih minimal satu serial number.');
      return;
    }
    serialSelection.forEach((serialUuid) => {
      const serial = serialOptions.find((o) => o.uuid === serialUuid);
      if (serial) addProductToCart(pendingProduct, serial);
    });
    setSerialDialogOpen(false);
    setPendingProduct(null);
    setSerialOptions([]);
    setSerialSelection([]);
    showNotification('success', 'Barang retail dengan serial number berhasil ditambahkan.');
  };

  // ── Reset cart setelah bayar berhasil ──────────────────────────────────────
  const handlePaymentSuccess = () => {
    setCart([]);
    setNamaCustomer('');
    setNoted('');
    setPaymentDialogOpen(false);
  };

  // Satu aturan tata letak (struk/strukLayout.js): pratinjau, cetak browser dan Bluetooth sama dengan struk Flutter.
  const barisUntuk = (receipt) =>
    barisStrukKasir({
      receipt,
      cabangConfig,
      namaCabang: user?.cabang?.namacabang || 'Retail',
      kasir: user?.nama || 'Kasir',
      logoUrl: receiptLogoUrl,
    });

  const printBrowserReceipt = (receipt) => {
    if (!receipt?.items?.length) {
      showNotification('error', 'Tidak ada data nota untuk dicetak.');
      return;
    }
    cetakBrowser(barisUntuk(receipt));
  };

  // laci: true hanya untuk cetak otomatis setelah pembayaran (bukan tombol cetak ulang): laci terbuka bila diatur otomatis & ada uang tunai.
  const printBluetoothReceipt = async (receipt, { laci = false } = {}) => {
    if (!printerConnected || !printerInstance) {
      printBrowserReceipt(receipt);
      return;
    }
    try {
      setIsPrinting(true);
      const bukaLaci = laci && harusBukaLaciOtomatis(cabangConfig, receipt);
      await printerInstance.printBaris(barisUntuk(receipt), undefined, { laci: bukaLaci ? { pin: bacaLaci(cabangConfig).pin } : null });
      showNotification('success', 'Nota berhasil dicetak via Bluetooth.');
    } catch (error) {
      showNotification('error', error?.message || 'Gagal cetak Bluetooth, fallback ke browser.');
      printBrowserReceipt(receipt);
    } finally {
      setIsPrinting(false);
    }
  };

  const handlePaymentCompleted = async (receipt) => {
    kirimLayar(pesanSelesai({ total: receipt.total, bayar: receipt.customerCash, kembalian: receipt.change, metode: receipt.paymentMethod, nomorAntrian: receipt.nomorAntrian }, cabangLayar));
    setReceiptPreviewData(receipt);
    setReceiptPreviewOpen(true);
    if (printerConnected && printerInstance) {
      await printBluetoothReceipt(receipt, { laci: true });
    }
  };

  const handlePaymentSettled = () => {
    setProductReloadTick((prev) => prev + 1);
  };

  const handleCheckoutFromCart = (payload) => {
    if (!cart.length) {
      showNotification('warning', 'Keranjang masih kosong.');
      return;
    }
    if (!payload?.selectedPaymentMethod) {
      showNotification('warning', 'Pilih metode pembayaran terlebih dahulu.');
      return;
    }
    // Shift kasir wajib dibuka sebelum menerima pembayaran.
    if (adalahKasir && !shiftHook.shift) {
      setMintaShift(true);
      return;
    }
    // Shift terbuka lebih dari 24 jam (lupa ditutup): tutup dulu, hitung uang di laci.
    if (adalahKasir && shiftHook.terkunci) {
      setMintaTutupShift(true);
      return;
    }
    setPaymentDialogOpen(true);
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Shift kasir: buka / kas / tutup (wajib sebelum menerima pembayaran) */}
      {adalahKasir && <KartuShiftWeb
        shiftHook={shiftHook}
        mintaBuka={mintaShift}
        onMintaBukaSelesai={() => setMintaShift(false)}
        mintaTutup={mintaTutupShift}
        onMintaTutupSelesai={() => setMintaTutupShift(false)}
        namaKasir={user?.nama || user?.username}
        onPesan={(message) => showNotification('info', message)}
      />}
      <Grid container spacing={2}>
        {/* Kolom Kiri: Search + Produk */}
        <Grid item xs={12} md={7} lg={8}>
          <SearchBarRetail
            lookupCode={lookupCode}
            setLookupCode={setLookupCode}
            lookupLoading={lookupLoading}
            lookupProduct={lookupProduct}
            onLookup={lookupByKodebarang}
            cameraEnabled={cameraOpen}
            onToggleCamera={() => setCameraOpen((prev) => !prev)}
            cameraContent={
              <CameraDialog
                open={cameraOpen}
                onScan={(code) => lookupByKodebarangRef.current?.(code)}
                onNotification={showNotification}
                continuousMode={true}
              />
            }
            inputRef={inputRef}
          />
          <ProductDisplayRetail
            baseUrl={baseUrl}
            onAddToCart={handleAddFromDisplay}
            reloadTrigger={productReloadTick}
          />
        </Grid>

        {/* Kolom Kanan: Cart */}
        <Grid item xs={12} md={5} lg={4}>
          <CartRetail
            cart={cart}
            namaCustomer={namaCustomer}
            setNamaCustomer={setNamaCustomer}
            noted={noted}
            setNoted={setNoted}
            selectedPaymentMethod={selectedPaymentMethod}
            setSelectedPaymentMethod={setSelectedPaymentMethod}
            qrisEnabled={qrisEnabled}
            onIncrement={incrementCartItem}
            onDecrement={decrementCartItem}
            onRemove={removeCartItem}
            onCheckout={handleCheckoutFromCart}
            printerConnected={printerConnected}
          />
        </Grid>
      </Grid>

      {/* ── Dialogs ── */}
      {paymentDialogOpen && (
        <PaymentDialog
          open={paymentDialogOpen}
          onClose={() => setPaymentDialogOpen(false)}
          cart={cart}
          selectedPaymentMethod={selectedPaymentMethod}
          nonCashMethods={nonCashMethods}
          namaCustomer={namaCustomer}
          noted={noted}
          baseUrl={baseUrl}
          onSuccess={handlePaymentSuccess}
          onNotification={showNotification}
          onPaymentCompleted={handlePaymentCompleted}
          onQrisChange={setQrisLayar}
          onPaymentSettled={handlePaymentSettled}
        />
      )}

      {serialDialogOpen && (
        <SerialDialog
          open={serialDialogOpen}
          onClose={() => setSerialDialogOpen(false)}
          pendingProduct={pendingProduct}
          serialOptions={serialOptions}
          serialSelection={serialSelection}
          setSerialSelection={setSerialSelection}
          onConfirm={confirmSerialSelection}
        />
      )}

      <Dialog open={receiptPreviewOpen} onClose={() => setReceiptPreviewOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          Preview Nota{receiptPreviewData?.nomorAntrian ? ` · ANTRIAN ${receiptPreviewData.nomorAntrian}` : ''}
          {receiptPreviewData?.nomorAntrian && (
            <Button size="small" sx={{ ml: 1 }} onClick={() => panggilSuara(suaraDariLabel(receiptPreviewData.nomorAntrian, receiptPreviewData.namaCustomer))}>
              Panggil
            </Button>
          )}
        </DialogTitle>
        <DialogContent>
          {receiptPreviewData && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <StrukPratinjau baris={barisUntuk(receiptPreviewData)} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReceiptPreviewOpen(false)}>Tutup</Button>
          <Button
            variant="contained"
            onClick={() => printBluetoothReceipt(receiptPreviewData)}
            disabled={isPrinting}
          >
            {isPrinting ? 'Mencetak...' : 'Print'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Snackbar ── */}
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          severity={notification.severity}
          variant="filled"
          onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

// ─── RetailIndex: Router utama ────────────────────────────────────────────────
const RetailIndex = () => {
  const baseUrl = getApiBaseUrl();

  return (
    <LayoutRetail>
      <Routes>
        {/* Halaman kasir utama — layout 2 kolom */}
        <Route index element={<KasirPage baseUrl={baseUrl} />} />

        {/* Halaman lainnya */}
        <Route path="transaksi"  element={<TransaksiRetail />} />
        <Route path="detail"     element={<OrderDetailRetail />} />
        <Route path="profile"    element={<ProfileRetail />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/retail" replace />} />
      </Routes>
    </LayoutRetail>
  );
};

export default RetailIndex;